import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "skills",
    standalone: false
})
//override of visible skill name after changes
export class SkillsPipe implements PipeTransform {
    transform(skillName: string): string {
        if(skillName == "Archaeology") skillName = "Arch/cultural/tribal";
        if(skillName == "Engineer") skillName = "Engineer/Roads";
        if(skillName == "Fisheries") skillName = "Fisheries (T&E)";
        if(skillName == "Invasive Species/Botany") skillName = "Botany/Invasive Species";
        if(skillName == "Recreation Specialist") skillName = "Recreation/Trails";
        if(skillName == "Wildlife Biologist") skillName = "Wildlife (T&E)";
        return skillName;
    }
}
